export const clamp01 = (v) => Math.max(0, Math.min(1, v));

export const easeInOut = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);

export const getMaxPixelSize = () => Math.max(50, Math.min(window.innerWidth / 12, 110));

export const drawCoverImage = ({
    ctx,
    offscreenCtx,
    offscreenCanvas,
    img,
    canvasWidth,
    canvasHeight,
    pixelSize = 1,
    opacity = 1,
}) => {
    if (!ctx || !img || opacity <= 0 || !canvasWidth || !canvasHeight) {
        return;
    }

    const imgW = img.naturalWidth || img.videoWidth || 0;
    const imgH = img.naturalHeight || img.videoHeight || 0;
    if (!imgW || !imgH) {
        return;
    }

    const imgRatio = imgW / imgH;
    const targetRatio = canvasWidth / canvasHeight;

    let sx = 0;
    let sy = 0;
    let sWidth = imgW;
    let sHeight = imgH;

    if (imgRatio > targetRatio) {
        sWidth = imgH * targetRatio;
        sx = (imgW - sWidth) / 2;
    } else {
        sHeight = imgW / targetRatio;
        sy = (imgH - sHeight) / 2;
    }

    ctx.save();
    ctx.globalAlpha = clamp01(opacity);

    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const effectivePixelSize = Math.max(1, pixelSize * dpr);

    if (pixelSize <= 1 || effectivePixelSize <= 1.5 || !offscreenCtx || !offscreenCanvas) {
        ctx.imageSmoothingEnabled = true;
        ctx.drawImage(img, sx, sy, sWidth, sHeight, 0, 0, canvasWidth, canvasHeight);
    } else {
        const sampleW = Math.max(1, Math.round(canvasWidth / effectivePixelSize));
        const sampleH = Math.max(1, Math.round(canvasHeight / effectivePixelSize));

        if (offscreenCanvas.width !== sampleW || offscreenCanvas.height !== sampleH) {
            offscreenCanvas.width = sampleW;
            offscreenCanvas.height = sampleH;
        }

        offscreenCtx.imageSmoothingEnabled = true;
        offscreenCtx.drawImage(img, sx, sy, sWidth, sHeight, 0, 0, sampleW, sampleH);

        ctx.imageSmoothingEnabled = false;
        ctx.drawImage(offscreenCanvas, 0, 0, sampleW, sampleH, 0, 0, canvasWidth, canvasHeight);
    }

    ctx.restore();
};
